import React from 'react';
import PropTypes from 'prop-types';
import ValueProps from '../ValueProps';

import './Jumbotron.less';

const CNAME = 'Jumbotron';

const Jumbotron = ({ children, showValueProps }) => (
  <div className={CNAME}>
    <div className={`${CNAME}__wrapper`}>
      <div className={`${CNAME}__content`}>
        {children}
      </div>
      {showValueProps && <ValueProps />}
    </div>
  </div>
);

Jumbotron.propTypes = {
  showValueProps: PropTypes.bool.isRequired
};

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/universal/components/Jumbotron/Jumbotron.js